import { TimeConstants } from '../constants';
import UTIL from 'mroads-js-utils';
import constants from '../globalization';
import UTILLib from './index';

export default class TMSUtils {
  static storeBookings = [];

  static storeTags = [];

  static storeOccasions = [];

  static setStoreBookings(bookings) {
    TMSUtils.storeBookings = bookings;
  }

  static setStoreTags(tags) {
    TMSUtils.storeTags = tags;
  }

  static setStoreOccasions(occasions) {
    TMSUtils.storeOccasions = occasions;
  }

  static getStationNumber = (item) => {
    const stationIds = item.stationIds;
    if (stationIds && stationIds.length > 0) return stationIds[0];
    return "--";
  };

  static getTimeElapsed = (item) => {
    if (item.seatingStartDate) {
      const currentTime = new Date().getTime() / TimeConstants.SECOND;
      const seatTime = new Date(item.seatingStartDate).getTime() / TimeConstants.SECOND;
      const timeSpent = parseInt((currentTime - seatTime) / 60);
      if (timeSpent < 120) return `${timeSpent}m`;
      return "2h+";
    }
    return "--";
  };

  static getGuestName = (item) => {
    let name = "- -";
    if (item.firstName && item.lastName) {
      name = `${item.firstName} ${item.lastName}`;
    } else if (item.firstName) {
      name = item.firstName;
    } else if (item.lastName) {
      name = item.lastName;
    }
    return name;
  };

  static getGuestCount = (item) => {
    const count = item.partySize;
    return count || "- -";
  };

  static getPOSItems = check => {
    const checkItems = {};
    const seats = check && check.seats;
    check.items &&
      check.items.forEach((i) => {
        const itemSeats = i.seats;
        const isTableItem = i.seats.some((seat) => seat.tableOrder) || itemSeats.length === 0;
        const seat = seats && seats.find((s) => !!itemSeats.find((is) => s.id === is.seatId));
        const sectionTag = `${isTableItem ? constants.table : `${constants.sectionSeat} ${seat && (seat.name || seat.number)}`}`;
        const section = {
          name: sectionTag,
          selected: false,
          memberId: seat ? seat.memberId : null,
        };
        i.section = section;
        if (!checkItems[sectionTag]) {
          checkItems[sectionTag] = [i];
        } else {
          checkItems[sectionTag].push(i);
        }
      });
    return checkItems;
  };

  static getPendingPOSItems = (items, check) => {
    const checkItems = {};
    const seats = check.seats;
    items.forEach(i => {
      const itemSeats = i.seatIds;
      const isTableItem =
        itemSeats.map(each => UTILLib.getSeatsForSeatIds(each, check)).some(seat => seat.tableOrder) ||
        itemSeats.length === 0;
      const seat = seats.find(s => !!itemSeats.find(seatId => s.id === seatId));
      const sectionTag = `${isTableItem ? constants.table : `${constants.sectionSeat} ${seat.name || seat.number}`}`;
      const section = {
        name: sectionTag,
        selected: false,
        memberId: seat?.memberId,
      };
      i.section = section;
      if (!checkItems[sectionTag]) {
        checkItems[sectionTag] = [i];
      } else {
        checkItems[sectionTag].push(i);
      }
    });
    return checkItems;
  };

  static getElapsedTime = (bookingDate) => {
    const currentTime = new Date().getTime();
    var convertTime = bookingDate && bookingDate.includes('Z');
    let date;
    if (convertTime)
      date = new Date(bookingDate);
    else
      date = new Date(bookingDate + 'Z');
    const bookingTime = new Date(date).getTime();
    return currentTime - bookingTime;
  };

  static showTimeInMinsSecs = time => {
    if (!time || time < 0)
      return "00:00";
    const timeInSeconds = parseInt(time / TimeConstants.SECOND);
    const timeInMins = parseInt(timeInSeconds / 60);
    const secs = timeInSeconds % 60;
    const formattedSeconds = ('0' + secs).slice(-2);
    return `${timeInMins}:${formattedSeconds}`;
  };
}
